// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"2fb203f3","564":"42109ed3"}[chunkId] + ".chunk.js";
};